export enum InstanceServiceIdEnum {
  TAGGING = 'tagging',
  SPARK_BATCHES = 'spark-batches',

  PLAYBOARD = 'playboard',

  CONTEXTUALIZE = 'contextualize',
  EMPATHIZE = 'empathize',
  QUERY_SIGNALS = 'querysignals',
  TOP_CLICKED = 'topclicked',
}

export enum ServiceConfigFieldErrorEnum {
  REQUIRED = 'required',

  OBJECT_PROPERTIES = 'objectProperties',

  ARRAY_ITEMS = 'arrayItems',
  ARRAY_UNIQUE_ITEMS = 'arrayUniqueItems',
  ARRAY_MIN_ITEMS = 'arrayMinItems',
  ARRAY_MIN_ITEMS_ONE = 'arrayMinItemsOne',
  ARRAY_MAX_ITEMS = 'arrayMaxItems',
  ARRAY_MAX_ITEMS_ONE = 'arrayMaxItemsOne',

  STRING_PATTERN = 'stringPattern',
  STRING_ENUM = 'stringEnum',
  STRING_MIN_LENGTH = 'stringMinLength',
  STRING_MAX_LENGTH = 'stringMaxLength',

  NUMBER_INVALID_TYPE = 'numberInvalidType',
  NUMBER_INTEGER = 'numberInteger',
  NUMBER_MINIMUM = 'numberMinimum',
  NUMBER_EXCLUSIVE_MINIMUM = 'numberExclusiveMinimum',
  NUMBER_MAXIMUM = 'numberMaximum',
  NUMBER_EXCLUSIVE_MAXIMUM = 'numberExclusiveMaximum',
  NUMBER_MULTIPLE_OF = 'numberMultipleOf',

  JSON_FORMAT = 'jsonFormat',
}
